import { RootState } from "../reducers";

export const getVisibleLayers = ({ sharedLayers }: RootState): string[] => sharedLayers.visibleLayers;

export const getLayersOpacity = ({ sharedLayers }: RootState): Record<string, number> => sharedLayers.layersOpacity;

export const getGroupsExpanded = ({ sharedLayers }: RootState): Record<string, boolean> => sharedLayers.groupsExpanded;
